import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import Swal from "sweetalert2";
import UserBankAcountModel from '../../models/UserBankAcountModel';
import { RiEditBoxLine, RiVipCrown2Fill, RiCloseLine, RiCheckLine } from "react-icons/ri";

const validationSchema = Yup.object().shape({
    accountNumber: Yup.string().required('Không được để trống!'),
    accountName: Yup.string().required('Không được để trống!'),
    password: Yup.string().required('Không được để trống!').min(6, 'Mật khẩu tối thiểu 6 ký tự!'),
    password_level_two: Yup.string().required('Không được để trống!'),
});

function ModalUpdateAcount(props) {
    const [initialValues, setInitialValues] = useState({
        user_bank_id: '',
        accountNumber: '',
        accountName: '',
        password: '',
        password_level_two: '',
        bin: '',
        type: '',
        bank_name: '',
    });

    useEffect(() => {
        if (props.data) {
            setInitialValues({
                user_bank_id: props.data.id,
                accountNumber: props.data.bank_number,
                accountName: props.data.bank_username || '',
                password: props.data.password_decryption || '',
                password_level_two: props.data.password_level_two,
                bin: props.data.bin || props.bin,
                type: props.data.type || props.type,
                bank_name: props.data.name || props.bankName,
            });
        }
    }, [props.data]);

    const onSubmit = (values) => {
        UserBankAcountModel.updateUserBankAcount(values).then((res) => {
            if (res.success == true) {
                Swal.fire({
                    icon: "success",
                    title: "Cập nhật thành công!",
                    showConfirmButton: false,
                    timer: 2000
                });
                setTimeout(() => {
                    props.reloadPage(props.id, props.type);
                    props.onHide();
                }, 2000);
            } else {
                Swal.fire({
                    icon: "error",
                    title: res.data,
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        }).catch(() => {
            Swal.fire({
                icon: "error",
                title: "Cập nhật thất bại!",
                showConfirmButton: false,
                timer: 2000
            });
        });
    };

    const isCombo = props.data && Number(props.data.is_from_combo) === 1;

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter" className="d-flex align-items-center gap-2">
                    <RiEditBoxLine size={18} style={{ color: 'var(--wus-text)' }} />
                    <span>Cập Nhật Thông Tin Tài Khoản</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    initialValues={initialValues}
                    enableReinitialize={true}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {({ errors, touched }) => (
                        <Form>
                            {isCombo ? (
                                <div className="d-flex align-items-center gap-2 p-3 mb-3" style={{ background: 'var(--wus-warning-bg)', border: '1px solid var(--wus-warning-border)', borderRadius: '10px', color: 'var(--wus-text-secondary)', fontSize: '12.5px' }}>
                                    <RiVipCrown2Fill size={20} style={{ color: 'var(--wus-warning-text)' }} className="flex-shrink-0" />
                                    <div>
                                        <strong style={{ color: 'var(--wus-warning-text)' }}>Đặc quyền Tài khoản VIP:</strong> Miễn phí <strong>100% (0 VNĐ)</strong> khi cập nhật Số tài khoản và thông tin ngân hàng.
                                    </div>
                                </div>
                            ) : (
                                ((props.is_UserPackage && props.PackAge && (props.is_UserPackage.total_edit_account >= props.PackAge.max_edit_account)) || props.is_UserPackage == null) && (
                                    <div className="p-3 mb-3" style={{ background: 'var(--wus-warning-bg)', border: '1px solid var(--wus-warning-border)', borderRadius: '10px', color: 'var(--wus-text-secondary)', fontSize: '12.5px' }}>
                                        ⚠️ <strong>Lưu ý:</strong> Khi sửa Số tài khoản đối với tài khoản thường sẽ mất phí <strong>100.000đ</strong>{props.is_UserPackage == null ? ' và 2.000đ phí kiểm tra tài khoản' : ''}.
                                    </div>
                                )
                            )}

                            <div className="mb-3">
                                <label htmlFor="accountNumber" className="form-label">Số tài khoản</label>
                                <Field className="form-control font-monospace" type="text" id="accountNumber" name="accountNumber" />
                                {errors.accountNumber && touched.accountNumber && (
                                    <div className="text-danger small mt-1">{errors.accountNumber}</div>
                                )}
                            </div>

                            <div className="mb-3">
                                <label htmlFor="accountName" className="form-label">Tên chủ tài khoản</label>
                                <Field className="form-control" type="text" id="accountName" name="accountName" />
                                {errors.accountName && touched.accountName && (
                                    <div className="text-danger small mt-1">{errors.accountName}</div>
                                )}
                            </div>

                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <label htmlFor="password" className="form-label">Mật khẩu App</label>
                                    <Field className="form-control" type="text" id="password" name="password" />
                                    {errors.password && touched.password && (
                                        <div className="text-danger small mt-1">{errors.password}</div>
                                    )}
                                </div>
                                <div className="col-sm-6">
                                    <label htmlFor="password_level_two" className="form-label">Mã OTP (6 số)</label>
                                    <Field className="form-control font-monospace" type="text" id="password_level_two" name="password_level_two" />
                                    {errors.password_level_two && touched.password_level_two && (
                                        <div className="text-danger small mt-1">{errors.password_level_two}</div>
                                    )}
                                </div>
                            </div>

                            <div className="modal-footer px-0 pb-0 mt-2">
                                <button type="button" className="btn btn-secondary" onClick={props.onHide}>
                                    <RiCloseLine className="me-1" size={16} />
                                    Hủy bỏ
                                </button>
                                <button type="submit" className="btn btn-primary">
                                    <RiCheckLine className="me-1" size={16} />
                                    Lưu thay đổi
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
}

export default ModalUpdateAcount;